import style from './Style.module.scss';

const Footer = () => {
	return (
		<div className={style.footer}>
			<img src="/images/footer.png?v=1" alt="footer" />
		</div>
	);
};

export default Footer;
